/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useEffect, useState } from 'react';
import { useConfiguration } from '../../redux/features/configuration/useConfiguration';
import { ConfigResourceProps } from '../../redux/enums/ConfigResourceProps';
import useProcedure from '../../procedure/useProcedure';

/**
 * Hook that delivers the uiSchema json once it is available.
 * The procedure is reuired for this resource.
 */
export function useUiSchema() {
  const [uiSchema, setUiSchema] = useState();
  const procedure = useProcedure();
  const uiSchemaConfiguration = useConfiguration(ConfigResourceProps.SUBMISSION_UI_SCHEMA, procedure?.id);

  useEffect(() => {
    if (uiSchemaConfiguration?.ready) {
      setUiSchema(uiSchemaConfiguration.resource);
    }
  }, [uiSchemaConfiguration.ready]);

  return {
    uiSchema,
  };
}
